import axiosInstance from "./Axios";

export class WalletAPI {
  static getAgentWalletByUserId = async (user_ref: string) => {
    try {
      const res = await axiosInstance.get(`/wallet-points/${user_ref}`);

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getLedgerStats = async (params?: { agent_id?: string }) => {
    try {
      const res = await axiosInstance.get(`/wallet-points/wallet/stats`, {
        params,
      });
      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Failed to fetch stats",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getTransactionHistory = async (params: {
    page?: number;
    limit?: number;
    transaction_type?: string;
    start_date?: string;
    end_date?: string;
    agent_id?: string;
  }) => {
    try {
      const res = await axiosInstance.get(`/wallet-points/wallet/history`, {
        params: params,
      });
      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Failed to fetch history",
        data: err?.response?.data,
        success: false,
      };
    }
  };
}
